import { ReactNode } from 'react';

import { UssdAppStatus, UssdAppAuth, UssdAppUserLimit, ApiDate } from '../../../../../../api/interfaces';

export interface UssdAppResponse {
  apps: UssdAppResponseItem[];
  limits: UssdAppUserLimit;
}

export interface UssdAppResponseItem {
  appId: string;
  appUrl: string;
  status: UssdAppStatus;
  debugEnabled: boolean;
  authorizationMethod: {
    type: UssdAppAuth;
    key?: string;
  };
  shortcode: string;
  createDate: ApiDate;
}

export interface UssdAppEditItem {
  appId: string;
  appUrl: string;
  status: UssdAppStatus;
  debugEnabled: boolean;
  authorizationMethod?: {
    type: UssdAppAuth;
    key?: string;
  };
}

export interface UssdAppTableData extends UssdAppResponseItem {
  id: string;
  actions: ReactNode;
}

export type UssdAppFormData = Omit<UssdAppResponseItem, 'shortcode' | 'createDate'>;

export enum BUSINESS_ERRORS {
  'APP_ID_ALREADY_EXISTS_IN_YOUR_APPS' = 'APP_ID_ALREADY_EXISTS_IN_YOUR_APPS',
  'APP_ID_ALREADY_EXISTS_IN_OTHER_DEVELOPER_APPS' = 'APP_ID_ALREADY_EXISTS_IN_OTHER_DEVELOPER_APPS',
  'CREATED_APPS_LIMIT_REACHED' = 'CREATED_APPS_LIMIT_REACHED',
  'APP_INVALID_URL' = 'APP_INVALID_URL',
  'APP_NOT_FOUND' = 'APP_NOT_FOUND'
}

export interface UssdAppTableRowActions {
  edit: (ussdAppFormData: UssdAppFormData) => void;
  openInEditor: (appId: string) => void;
}

export type APP_CREATION_PERMISSION_STATUS = 'ALLOWED' | 'CREATED_APPS_LIMIT_REACHED';
